import { render, staticRenderFns } from "./AgendamentoInsertTab.vue?vue&type=template&id=73133a5c&"
import script from "./AgendamentoInsertTab.vue?vue&type=script&lang=js&"
export * from "./AgendamentoInsertTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports